export default __webpack_public_path__ + "static/media/manuscript.93252c10.svg";